import * as actions from './actions';

export type State = {
  tempScenario: Record<string, any>;
  modelledScenario: Record<string, any>;
  updatedFields: Record<string, any>;
  error: Record<string, any>;
};

export default (
  state: State = {
    tempScenario: {},
    modelledScenario: {},
    error: {
      participantSocialSecurityAmountError: '',
      spouseSocialSecurityAmountError: '',
    },
    updatedFields: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_SOCIAL_SECURITY:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        updatedFields: {},
      };
    case actions.UPDATE_SOCIAL_SECURITY_DATA:
      return {
        ...state,
        tempScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
        updatedFields: {
          ...state.updatedFields,
          ...action.payload,
        },
      };
    case actions.MODEL_SOCIAL_SECURITY_SCENARIO:
      return {
        ...state,
        modelledScenario: {
          ...state.tempScenario,
        },
      };
    case actions.UPDATE_SOCIAL_SECURITY_ERROR:
      return {
        ...state,
        error: {
          ...state.error,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
